export default __webpack_public_path__ + "static/media/Land_Chest.28e6b4b1.png";